import { render } from "./TariffLockBadge.vue?vue&type=template&id=3c750a7b&scoped=true"
import script from "./TariffLockBadge.vue?vue&type=script&lang=js"
export * from "./TariffLockBadge.vue?vue&type=script&lang=js"

import "./TariffLockBadge.vue?vue&type=style&index=0&id=3c750a7b&scoped=true&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c750a7b"]])

export default __exports__